import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=035cd3aa&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"
import style0 from "./HeaderView.vue?vue&type=style&index=0&id=035cd3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cd3aa",
  null
  
)

export default component.exports